<template>
    <v-card>
        <vuetify-tool-bar
            :current-file="currentFile"
            :current-path="currentPath"
            @load-folder="loadFolder"
            @reload-folder="loadFolder( currentPath )"
            @open-modal-create-folder="showCreateFolderModal = true"
            @open-modal-delete-item="showDeleteItemModal = true"
            @open-modal-move-item="showMoveItemModal = true"
            @open-modal-rename-item="showRenameItemModal = true"
            @upload-file="uploadFile"
        />
        <v-sheet>
            <v-container fluid :style="{minHeight: '75vh'}">
                <div
                    id="mediaManagerDropZone"
                    class="dropzone">
                    <v-card v-if="loading" :loading="loading" min-height="450" class="media-manager-alternative-content">
                        <template slot="progress">
                            <v-overlay absolute class="d-flex flex-column text-center">
                                <div>
                                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                                        <span>In curs de incarcare{{ uploadProgress > 0 ? ` ${uploadProgress}%` : '...' }}</span>
                                    </v-progress-circular>
                                </div>
                            </v-overlay>
                        </template>
                    </v-card>
                    <div v-else>
                        <div class="media-manager-file-browser">
                            <v-row>
                                <v-col sm="12">
                                    <v-breadcrumbs :items="vuetifyBreadCrumbs" class="pa-1">
                                        <template v-slot:item="{ item }">
                                            <v-breadcrumbs-item
                                                v-if="item.path"
                                                @click="loadFolder(item.path)"
                                            >
                                                {{ item.text.toUpperCase() }}
                                            </v-breadcrumbs-item>
                                            <v-breadcrumbs-item v-else>
                                                {{ item.text.toUpperCase() }}
                                            </v-breadcrumbs-item>
                                        </template>
                                    </v-breadcrumbs>
                                </v-col>
                            </v-row>

                            <v-alert
                                border="top"
                                colored-border
                                type="info"
                                elevation="2"
                                v-if="isFolderEmpty">
                                <div class="title">Acest director este gol.</div>
                                <div>
                                    Trageti aici fisierele care doriti sa le incarcati.
                                </div>
                            </v-alert>

                            <v-row v-else>
                                <v-col :cols="!isFile(currentFile) || isFolder(currentFile) ? '12' : '9'">
                                    <v-sheet elevation="2">
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        Nume
                                                    </th>
                                                    <th class="text-left">
                                                        Tip fisier
                                                    </th>
                                                    <th class="text-left">
                                                        Data
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr
                                                    v-for="folder in folders"
                                                    :key="folder.name"
                                                    :class="[ (folder == currentFile) ? 'bg-primary' : '' ]"
                                                >
                                                    <td>
                                                        <i class="icon-folder"/>
                                                        <a
                                                            class="word-wrappable"
                                                            href="javascript:void(0);"
                                                            @click="previewFile(folder)"
                                                            @dblclick="loadFolder(folder.fullPath)"
                                                            @keyup.enter="loadFolder(folder.fullPath)"
                                                        >
                                                            {{ folder.name }}
                                                        </a>
                                                    </td>
                                                    <td>director</td>
                                                    <td>{{ folder.modified | formatDate('DD/MM/YYYY') }}</td>
                                                </tr>

                                                <tr
                                                    v-for="file in files"
                                                    :key="file.name"
                                                    :class="[ (file == currentFile) ? 'bg-primary' : '' ]">
                                                    <td>
                                                        <i v-if="isImage(file)" class="icon-image"></i>
                                                        <i v-else class="icon-file-text2"></i>
                                                        <a
                                                            class="word-wrappable"
                                                            href="javascript:void(0);"
                                                            @click="previewFile(file)"
                                                            @keyup.enter="selectFile(file)"
                                                            @dblclick="selectFile(file)"
                                                        >
                                                            {{ file.name }}
                                                        </a>

                                                    </td>
                                                    <td>{{ file.mimeType }}</td>
                                                    <td>{{ file.modified | formatDate('DD/MM/YYYY') }}</td>
                                                </tr>
                                                </tbody>
                                                <tfoot>
                                                <tr>
                                                    <td colspan="3">
                                                        {{ itemsCount }} {{ itemsCount > 1 ? 'elemente' : 'element' }}.
                                                    </td>
                                                </tr>
                                                </tfoot>
                                            </template>
                                        </v-simple-table>
                                    </v-sheet>
                                </v-col>
                                <v-col v-if="isFile(currentFile) && ! isFolder(currentFile)" cols="3">
                                    <v-sheet elevation="2" class="pa-5">
                                        <vuetify-preview-sidebar :prefix="prefix" :current-file="currentFile"/>
                                    </v-sheet>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </div>
            </v-container>
        </v-sheet>


        <create-folder-dialog
            :current-path="currentPath"
            :prefix="prefix"
            :show="showCreateFolderModal"
            @media-modal-close="showCreateFolderModal = false"
            @reload-folder="loadFolder( currentPath )"
        />

        <delete-dialog
            :current-path="currentPath"
            :current-file="currentFile"
            :prefix="prefix"
            :show="showDeleteItemModal"
            @media-modal-close="showDeleteItemModal = false"
            @reload-folder="loadFolder( currentPath )"
        />

        <move-item-dialog
            :current-path="currentPath"
            :current-file="currentFile"
            :prefix="prefix"
            :show="showMoveItemModal"
            @media-modal-close="showMoveItemModal = false"
            @reload-folder="loadFolder( currentPath )"

        />

        <rename-item-dialog
            :current-path="currentPath"
            :current-file="currentFile"
            :prefix="prefix"
            :show="showRenameItemModal"
            @media-modal-close="showRenameItemModal = false"
            @reload-folder="loadFolder( currentPath )"
        />
    </v-card>
</template>

<script>
    import MediaManager from "../../../packages/media-manager/js/components/MediaManager";
    import VuetifyToolBar from "./Components/ToolBar";
    import VuetifyPreviewSidebar from "./Components/PreviewSideBar";
    import CreateFolderDialog from "./Dialogs/CreateFolderDialog";
    import MoveItemDialog from "./Dialogs/MoveItemDialog";
    import DeleteDialog from "./Dialogs/DeleteDialog";
    import RenameItemDialog from "./Dialogs/RenameItemDialog";
    export default {
        extends: MediaManager,
        components: {
            VuetifyToolBar,
            VuetifyPreviewSidebar,
            CreateFolderDialog,
            MoveItemDialog,
            DeleteDialog,
            RenameItemDialog
        },
        computed: {
            vuetifyBreadCrumbs() {
                var breadcrumbs = Object.keys(this.breadCrumbs).map(key => {
                    return {
                        path: key,
                        text: this.breadCrumbs[key] === '\\' ? 'Storage' : this.breadCrumbs[key]
                    }
                })
                breadcrumbs.push({
                    path: undefined,
                    text: this.folderName === '\\' ? 'Storage' : this.folderName
                })
                return breadcrumbs.filter(item => ['files'].indexOf(item.text.toLowerCase()) < 0)
            }
        }
    }
</script>
